export const slbCommon = {
    domain: {
        register: "Register to view the pricing",
        registerToGetPricing: "Register to get the pricing",
        registerToViewPrices: "Register to view prices",
        pricing: "Starting at {{price}} user / month",
        pricingSubscription: "Starting at {{currency}} <b><sup>$</sup>{{price}}</b> user / month",
        pricingFrom: "From {{price}} / month",
        loginForDetails: "Login for details",
        interestedIn: "Interested in this extension?"
    },
    caseStudies: {
        fullCase: "View the full case study"
    }, 
    slb: {
        learn: "Learn More",
        home: "Home",
        contactUs: {
            title:"Contact us",
            terms: "TCC statement<br/>If your request is related to unconventional work (deepwater, arctic offshore and shale) anywhere in the world, please ensure that you are aware of Trade Compliance laws that apply to this domain.<br/><br/> The chat application is not compliant for operations relating to Cuba, Iran, Sudan and Syria.",
            chatAvailability: "Online chat support is only available between 8:00AM to 5:00PM CST",
            success: "Your request has been submitted"
        },
        transition: {
            title: "You are being directed to the registration page.",
            subtitle: "After authentication, you will be returned to the Commerce site."
        },
        continue: "Continue",
        cancel: "Cancel",
        apply: "Apply",
        close: "Close",
        price: 'Price',
        next: 'NExT',
        services: "Services",
        ok: "OK",
        viewDetails: "View Details",
        productsFound: "{{quantity}} products found",
        configurePricing: "Configure pricing",
        additionalInformation: "Additional Information",
        registrationProcess: "Your registration is being processed",
        overview: "Overview",
        features: "Features",
        applications: "Applications",
        benefits: "Benefits",
        specifications: "Specifications",
        platform: "Platform",
        wouldLike: "I would like to",
        welcome: "Welcome {{name}}",
        completeRegistration: "Help us to complete your registration by providing the following information",
        try: 'Try',
        buy: 'Buy',
        rent: 'Rent',
        month: '{{index}} month',
        months: '{{index}} months',
        basePrice: 'Base price',
        discount: '15% discount',
        sale: 'Sale',
        freeWeek: '2 weeks free evaluation',
        allOfferings: "All offerings",
        allSolutions: "All Solutions",
        generatingOrder: 'Your order is being processed. This may take a moment...',
        logout: {
            title: "Before you go...",
            description: "<p>Are you sure you want to leave this page? <br>The quote progress will be saved.</p>",
            continue: "No, I want to continue",
            exit: "Yes, Exit"
        },
        welcomeBack: {
            title: "Welcome back, {{user}}",
            description: "<p>Or you can create a new quote. <br>Your previously saved quote will be lost.</p>",
            view: "View and Edit Quote",
            create: "Create New Quote",
            noticed: "We noticed you left something behind"
        },
        downloadBrochure: "Download brochure",
        sales: {
            claimOffer: "Claim Your -15% Off Offer",
            description: "You will receive an email with your offer within 24 hours. We will explain in detail how we can help you find a cost-effective solution to meet your specific needs.",
            contactMe: "Contact Me <span>-></span>",
            signUp: "Sign Up Now",
            signUpDescription: "Please enter your information to claim your offer."
        },
        registrationComplete: "Successfull registration, company, country, name information was added to your profile.",
        registrationCompleteFail: "Registration failed. Please check the company, country, and name information, and try again.",
        "quote.action.approved": "Approved",
        "quote.action.rejected": "Rejected",
        "expired": "There is an issue with your payment details. Click <a href='/my-account/orders-history' >here</a> to update your payment method.",
        videoLibrary: "Video Library",
        queryNotFound: '<h2>"{{query}}" was not found</h2> Please search by name, platform, developer, domain or use filtering instead',
        seeAllProducts: "Show all products",
        notFound: '<h2>"{{query}}" was not found</h2>',
        userPreferencesError: "Something went wrong saving your preferences, please try again. If problem persist, contact support.",
        userGetPreferencesError: "Something went wrong getting your preferences, please try again. If problem persist, contact support.",
        skip: 'Skip for now',
        noMoreResults: "You've reached the end — all available plugins for your search have been loaded.",
        noMoreSubscriptionsResults: "You've reached the end — all available subscriptions for your search have been loaded.",
        appsFeatured: "Apps featured",
        contactAnExpert: "Speak to an expert",
        learnMoreAbout: "Learn more about our solutions",
        learnMore: "Learn more",
        loadMore: "Load more",
        viewCase: "View case study",
        subscriptionCriteria: "Subscription criteria",
        appsIncluded: "Apps included",
        submitTicket: "Submit a ticket to get more information about pricing, availability, and deployment options.",
        submitTicketAction: "Submit ticket for more info",
        viewAllSubscriptions: "View more subscriptions",
        includesDesktop: "Includes <a>SLB Virtual Desktop</a>",
        allDomains: "all domains",
        showingSubscriptions: "Showing {{total}} subscriptions",
        compareSubscriptions: "Compare related subscriptions",
        apps: 'Apps',
        modules: 'Modules',
        plugins: 'Plugins',
        addOns: 'Optional add ons',
        module: 'Module',
        plugin: 'Plugin',
        "case-studie": 'Case study',
        app: 'App',
        search: 'Search',
        viewPlugins: 'View modules & plugins',
        modulesIncluded: 'Modules included',
        pluginsIncluded: 'Plugins included',
        cost: 'Cost',
        copyright: 'Copyright © {{year}} SLB. All rights reserved',
        emailSuccess: 'Your information has been successfully submitted. You will receive a response shortly.'
    },
    slbPdpDividedBanner: {
        domainprofilesOnDelfi: 'Domain profiles on Delfi',
        edgeSolutions: 'Edge Solutions'
    },
    forms: {
        firstName: "First name",
        lastName: "Last name",
        enterFirstName: "Enter first name",
        enterLastName: "Enter last name",
        companyName: "Company name",
        enterCompanyName: "Enter company name",
        name: "Name",
        phone: "Telephone",
        email: "Email address",
        email2: "Email",
        country: "Country",
        problemArea: "Problem area",
        issueDetails: "Issue details",
        sendEmail: "Send email",
        startChat: "Start chat",
        cancel: "Cancel",
        placeholderSelect: "Please select an option",
        emailUs: 'Email us',
        chatWithUs: 'Chat with us',
        comments: 'Enter comments:',
        errors: {
            required: "Required",
            email: "Please enter a valid email",
            requiredValue: "Value can't be removed",
            fillRequired: "Please enter all required fields",
            problemArea: "The Problem Area selected is not available for your country",
            min: "The minimun value required is {{min}}",
            minValue: "Value can't be lower than {{min}}",
            maxValue: "Value can't be higher than {{max}}",
            incorrectFormat: "{{label}} incorrect format",
            patternFirstName: "Please enter a valid {{field}} using alphabetic characters only.",
            maxLength: "The max length of the field is {{length}}.",
            minLength: "The min length of the field is {{length}}.",
            requiredContactSales: "Please fill out this field. It must be between 2 and 50 characters long, and spaces are not allowed.",
        }
    },
    addToCartPopUp: {
        nextSteps: 'Finalize software details steps before you checkout.',
        view: 'View',
        addedToCart: 'added to Cart.',
        addedToCartTitle: 'Added to cart',
        services: 'Services'
    },
    pluginFacet: {
        filters: 'Filters',
        resetAll: 'Reset all',
        clearAll: 'Clear all filters',
        serviceDomain: 'Domain',
        allCategories: 'Category',
        vendorName: "Providers",
        vendorSingleName: "Provider",
        vendorNamed: "Provided By",
        developedBy: "Developed by",
        platformType: "Products",
        platform: "Platform",
        domains: "Domain",
        eccn: "ECCN",
        challenges: "Challenges",
        lifecycle: "Lifecycle Conventional",
        applicationName: 'Apps',
        subscriptionDomain: 'Domain'
    },
    facet: {
        filters: 'Filters',
        resetAll: 'Reset all',
        serviceDomain: 'Domain',
        allCategories: 'Category',
        vendorName: "Developer",
        vendorNamed: "Developed By",
        platformType: "Platform",
        domains: "Domain",
        eccn: "ECCN",
        challenges: "Challenges",
        lifecycle: "Lifecycle Conventional"
    },
    pagination: {
        page: 'page',
        pages: 'pages',
        itemsPerPage: '{{size}} items per page',
    },
    autocomplete: {
        placeholder: 'Search by name, platform, developer, domain'
    },
    platformType: {
        petrel: 'Petrel XD',
        techlog: 'Techlog XD',
        studiomanager: 'Studiomanager',
        prosource: 'Prosource',
        merak: 'Merak',
        petromod: 'Petromod',
        eclipse: 'Eclipse'
    }
};
